import React from "react";
import { QuoteStatus } from "../../../utils/Quote/Quote";
import style from "../Quotebar.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";

const expirationRemainingString = (seconds) => {
  if (seconds >= 3600) {
    return `${Number(seconds / 3600).toFixed(1)}h`;
  } else if (seconds >= 60) {
    return `${Number(seconds / 60).toFixed(1)}m`;
  } else {
    return `${Number(seconds)}s`;
  }
};

export const Icon = (props) => {
  const { quote, isAdvisor } = props;
  const { AdvisorQuoteExpireAt, expired, expirateIn } = quote;

  switch (quote.AdvisorQuoteStatus) {
    case QuoteStatus.WAITING:
      return <i className="icon-question icons font-2xl d-block mt-1"></i>;
    case QuoteStatus.PRICED:
      if (expired) {
        return <i className="icon-close icons font-2xl d-block mt-1"></i>;
      }
      if (isAdvisor) {
        return (
          <CircularProgress
            static
            size="40"
            stroke="#40b316"
            strokeWidth="5"
            text={expirationRemainingString(expirateIn)}
            percentage={100 - (expirateIn / (quote.AdvisorQuoteDuration * 60)) * 100}
          />
        );
      }
      return <i className="icon-check icons font-2xl d-block mt-1"></i>;
    case QuoteStatus.USED:
      return <i className="icon-check icons font-2xl d-block mt-1"></i>;
    case QuoteStatus.REJECTED_BY_RECEIVER:
    case QuoteStatus.REJECTED_BY_SENDER:
      return <i className="icon-close icons font-2xl d-block mt-1"></i>;
  }
};
